import { webfontBaseUrl } from 'elements/icon/font-awesome/v6.5.1/webfont-base-url.js'
import { css, CSSResult } from 'lit'


/*!
 * Font Awesome Pro 6.5.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license (Commercial License)
 * Copyright 2023 Fonticons, Inc.
 */
export const faSolid: CSSResult = css`
  :root, :host {
    --fa-style-family-classic: 'Font Awesome 6 Pro';
    --fa-font-solid: normal 900 1em/1 'Font Awesome 6 Pro';
  }
  
  @font-face {
    font-family: 'Font Awesome 6 Pro';
    font-style: normal;
    font-weight: 900;
    font-display: block;
    src: url("${webfontBaseUrl}/fa-solid-900.woff2") format("woff2"), url("${webfontBaseUrl}/fa-solid-900.ttf") format("truetype");
  }`

// Split to allow the @font-face to be loaded at the document level,
// while the class styles are loaded at the element level.
export const faSolidClass: CSSResult = css`
  .fas,
  .fa-solid {
    font-weight: 900;
  }`
